<script setup lang="ts">
import { useScreenSize } from '@/composables/screen-size'
import useProductStore from '@/stores/product'
import { AppBlock, AppButton, AppDrawer } from 'lilasia-ui'
import { useI18n } from 'vue-i18n'
import ShareButton from './ShareButton.vue'

const { isMobile } = useScreenSize()
const { t } = useI18n()
const productStore = useProductStore()
</script>

<template>
  <AppDrawer
    v-if="isMobile"
    v-model="productStore.showQuickAction"
    position="bottom"
  >
    <AppBlock class="w-dvw">
      <div class="flex gap-16 px-24 py-16">
        <ShareButton />
        <AppButton
          color="yellow"
          :icon="productStore.addedToCartStatus ? 'check' : 'add'"
          :text="productStore.addedToCartStatus ? t('added_to_cart') : t('add_to_cart')"
          block
          @click="productStore.showPurchaseOptions = true"
        />
      </div>
    </AppBlock>
  </AppDrawer>
</template>
